// Footer.jsx
import { Box, Container, Typography } from "@mui/material";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Container maxWidth="sm" aria-label="footer-container">
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          component="p"
          dir="ltr"
        >
          © Eldan 2026
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          component="p"
          dir="ltr"
        >
          405-JUL-2026
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;